var _ = require('lodash');

function getNestedValue (obj, path, fallback) {
  const last = path.length - 1

  if (last < 0) return obj === undefined ? fallback : obj

  for (let i = 0; i < last; i++) {
    if (obj == null) {
      return fallback
    }
    obj = obj[path[i]]
  }

  if (obj == null) return fallback

  return obj[path[last]] === undefined ? fallback : obj[path[last]]
}

function getObjectValueByPath (obj, path, fallback) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (obj == null || !path || typeof path !== 'string') return fallback
  if (obj[path] !== undefined) return obj[path]
  path = path.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
  path = path.replace(/^\./, '') // strip a leading dot
  return getNestedValue(obj, path.split('.'), fallback)
}

export function defaultFilter (value, search, item) {
  return value != null &&
    search != null &&
    typeof value !== 'boolean' &&
    value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
}

export function searchItems_ (items, search) {
  if (!search) return items
  search = search.toString().toLowerCase()
  if (search.trim() === '') return items
  return items.filter(item => Object.keys(item).some(key => defaultFilter(getObjectValueByPath(item, key), search, item)))
}

export function searchItems2 (items, search) {
  if (!search) return items
  search = search.toString().toLowerCase()
  if (search.trim() === '') return items
  return items.filter(item => Object.keys(item[0]).some(key => defaultFilter(getObjectValueByPath(item[0], key), search, item[0])))
}


export function searchItems (items, search, reverse) {
  if (!search) return items

  search = search.toString().toLowerCase()
  if (search.trim() === '') return items
  return _.filter(items, (item) => {
      var v = search.trim().split(/\s+/);
      var arr = _.toArray(item).toString().toLocaleLowerCase();
      if (reverse) {
        return _.every( v, (s) => arr.indexOf(s.toLocaleLowerCase()) === -1)
      } else {
        return _.every( v, (s) => arr.indexOf(s.toLocaleLowerCase()) !== -1)
      }
    })
}

export function isEqual (object, other) {
  return _.isEqual(object, other);
}

export function clone (object) {
  return _.cloneDeep(object);
}

export function difference(array, other) {
  var object = _.keyBy(array, 'id');
  var base = _.keyBy(other, 'id');

  function changes(object, base) {
    const accumulator = {};
    Object.keys(base).forEach((key) => {
      if (object[key] === undefined) {
        accumulator[`-${key}`] = undefined;
      }
    });
    return _.transform(
      object,
      (accumulator, value, key) => {
        if (base[key] === undefined) {
          accumulator[`+${key}`] = value;
        } else if (!_.isEqual(value, base[key])) {
          accumulator[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
        }
      },
      accumulator
    );
  }
  return _.values(changes(object, base));
}
